// src/utils/stationsrang.js
//
// Wer war an einer Station der Beste? Die Ergebnisliste zeigt das direkt an der
// Station, damit es nicht mehr aus der Einzelliste herausgesucht werden muss.

/**
 * Die Ergebnisse auf Platz 1 – bei Gleichstand mehrere.
 *
 * Massgeblich ist der in der Berechnung vergebene Stationsplatz (`rank`, siehe
 * assignPoints() in functions/calculateResults.js). Der beruecksichtigt die
 * Richtung der Station (niedrigere Zeit ist besser) und teilt sich bei
 * Gleichstand den Platz. Nur fuer Altbestand ohne `rank` wird ersatzweise nach
 * den meisten Punkten entschieden.
 *
 * @param {Array<{rank?: number|null, points?: number|null}>} ergebnisse
 *        bereits auf EINE Kategorie eingeschraenkt – Kinder und Erwachsene
 *        werden getrennt gewertet.
 */
export function besteErgebnisse(ergebnisse) {
  const liste = Array.isArray(ergebnisse) ? ergebnisse : [];

  const raenge = liste.map((r) => r?.rank).filter((x) => Number.isFinite(x));
  if (raenge.length > 0) {
    const bester = Math.min(...raenge);
    return liste.filter((r) => r?.rank === bester);
  }

  const punkte = liste.map((r) => r?.points).filter((x) => Number.isFinite(x));
  if (punkte.length === 0) return [];
  const meiste = Math.max(...punkte);
  return liste.filter((r) => r?.points === meiste);
}
